import I18n from 'I18n';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { usageTracker } from '../../usage-tracker/usageTracker';
import { getUsageTrackingChannel } from '../../usage-tracker/trackerChannelIdMapping';
import { SearchIcon } from 'foundations-assets';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { jsx as _jsx } from "react/jsx-runtime";
const ContactPromotionButton = ({
  setShowContactPromotionModal,
  isDeletedContact = false,
  genericChannelId
}) => {
  const handleOnClick = () => {
    setShowContactPromotionModal(true);
    usageTracker.track('contact-promotion', {
      action: 'contact promotion button clicked',
      channel: genericChannelId && getUsageTrackingChannel(genericChannelId)
    });
  };
  const unKnownVisitorTooltip = I18n.text('conversations-inbox-message-history.common-message.sender.unknownVisitorSearchIconTooltip');
  const deletedContactToolTip = I18n.text('conversations-inbox-message-history.common-message.sender.deletedContactSearchIconTooltip');
  return /*#__PURE__*/_jsx(Tooltip, {
    title: isDeletedContact ? deletedContactToolTip : unKnownVisitorTooltip,
    children: /*#__PURE__*/_jsx(IconButton, {
      use: "transparent",
      size: "md",
      disabled: isDeletedContact,
      onClick: handleOnClick,
      "data-test-id": "contact-promotion-btn",
      paddingBlockStart: "100",
      paddingBlockEnd: "100",
      children: /*#__PURE__*/_jsx(SearchIcon, {})
    })
  });
};
ContactPromotionButton.displayName = 'ContactPromotionButton';
export default ContactPromotionButton;